import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import * as StringHelper from 'js/common/string_helper';
import {ENUMS, MAPS} from 'js/common';

class Filters extends Component {
    static propTypes = {
        updateFilterState: PropTypes.func.isRequired,
        postStatusIncludes: PropTypes.arrayOf(PropTypes.string),
        approvedPostStatusIncludes: PropTypes.arrayOf(PropTypes.string)
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            isDirty: false,
            postStatusIncludes: props.postStatusIncludes,
            approvedPostStatusIncludes: props.approvedPostStatusIncludes
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            open: false,
            isDirty: false,
            postStatusIncludes: nextProps.postStatusIncludes,
            approvedPostStatusIncludes: nextProps.approvedPostStatusIncludes
        });
    }

    handleStateChange = ({stateName, value}) =>
        this.setState(
            {
                [stateName]: value,
                isDirty: true
            },
            () => {
                const {updateFilterState, active_view} = this.props;
                const currentPick =
                    active_view === 'brand_approved_posts'
                        ? R.pick(['approvedPostStatusIncludes'])
                        : R.pick(['postStatusIncludes']);
                R.pipe(
                    currentPick,
                    updateFilterState
                )(this.state);
            }
        );

    persistStateToQuery = () => {
        const {updateFilterState, active_view} = this.props;
        const currentPick =
            active_view === 'brand_approved_posts'
                ? R.pick(['approvedPostStatusIncludes'])
                : R.pick(['postStatusIncludes']);
        R.pipe(
            currentPick,
            updateFilterState
        )(this.state);
    };

    toggleOpen = () => {
        this.setState({open: !this.state.open});
    };

    displayPostStatusSelects = () => {
        const {postStatusIncludes} = this.state;
        const {active_view} = this.props;
        const contentENUM =
            active_view === 'brand_approved_posts'
                ? ENUMS.ApprovedToPostFilter
                : ENUMS.ContentApprovalStatus;
        const contentMAP =
            active_view === 'brand_approved_posts'
                ? MAPS.ApprovedToPostFilter
                : MAPS.ContentApprovalStatus;
        const contentApprovalStatusesEnum = R.merge(contentENUM, {
            ALL: 'all'
        });
        const contentApprovalStatusesMaps = R.merge(contentMAP, {
            all: 'All'
        });

        return R.pipe(
            R.map(status => {
                const isChecked = R.contains(status, postStatusIncludes);
                const stateName =
                    active_view === 'brand_approved_posts'
                        ? 'approvedPostStatusIncludes'
                        : 'postStatusIncludes';
                const payload = {
                    stateName,
                    value: status
                };

                const prettyOpsStatus = R.pipe(
                    R.toLower,
                    R.replace(/_/g, ' '),
                    StringHelper.toTitleCase
                )(contentApprovalStatusesMaps[status]);

                return (
                    <MenuItem
                        active={isChecked}
                        key={status}
                        eventKey={payload}
                        onSelect={() => this.handleStateChange(payload)}
                    >
                        {prettyOpsStatus}
                    </MenuItem>
                );
            }),
            R.values
        )(contentApprovalStatusesEnum);
    };

    render() {
        const {open} = this.state;

        const postStatusSelects = this.displayPostStatusSelects();

        return (
            <DropdownButton
                id="dropdown-filter"
                bsStyle="link"
                className="btn-group-sort-by"
                onClick={this.toggleOpen}
                open={open}
                pullRight
                key={2}
                title="Filter By"
            >
                <MenuItem header>
                    <b>Content Status</b>
                </MenuItem>
                {postStatusSelects}
            </DropdownButton>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/filters.js